import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../foundations/theme.es.js";
import { styled } from "@mui/material";
import { forwardRef } from "react";
import MUIChip from "../../../node_modules/@mui/material/Chip/Chip.es.js";
const ChipStyled = styled(MUIChip)(({
  color,
  variant
}) => {
  const isVariantOutlined = variant === "outlined";
  const needsTextColorAdjustment = ["secondary", "info"].includes(color ?? "");
  if (isVariantOutlined && needsTextColorAdjustment) {
    return {
      color: theme.palette.text.primary
    };
  }
});
const Chip = forwardRef(function Chip2({
  children,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsx(ChipStyled, { ref, ...rest, children });
});
export {
  Chip
};
//# sourceMappingURL=chip.es.js.map
